import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import memberListSLice from "./slices/memberSlice";
import loginSlice from "./slices/loginSlice";
import resetPasswordEmailSlice from "./slices/resetPasswordEmailSlice";
import merchantSlice from "./slices/merchantSlice";
import recieptsSlice from "./slices/recieptsSlice";
import adminSlice from "./slices/adminSlice";
import roleSlice from "./slices/roleSlice";

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import LoyaltyPointsSlice from "./slices/LoyaltyPointsSlice";
import SalesSlice from "./slices/SalesSlice";
import pointsSlice from "./slices/UpdateLoyaltyPoints";
import otpSlice from "./slices/otpSlice";
import financeSlice from "./slices/financeSlice";
import shopUserSlice from "./slices/shopUserSlice";
import PhysicalVoucherSlice from "./slices/PhysicalVoucherSlice";
import corporateSlice from "./slices/corporateSlice";
const persistConfig = {
  key: "root",
  storage,
};

const reducer = combineReducers({
  login: loginSlice,
  user: userReducer,
  resetPassword: resetPasswordEmailSlice,
  getMemberList: memberListSLice,
  getMerchantList: merchantSlice,
  getAdminList: adminSlice,
  getReceiptsList: recieptsSlice,
  getRoleList: roleSlice,
  loyaltyPoints: LoyaltyPointsSlice,
  pointsSlice: pointsSlice,
  financeSlice: financeSlice,
  otpSlice: otpSlice,
  shopUserSlice: shopUserSlice,
  physicalVoucherSlice: PhysicalVoucherSlice,
  corporateSlice: corporateSlice,
});

const persistReducers = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: {
    persistReducers,
    salesSlice: SalesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
